<div>
    <div class="panel">
        <div class="mb-5">
            <div class="mb-4 flex flex-col items-center justify-center sm:flex-row sm:justify-between">
                <div class="mb-4 sm:mb-0">
                    <div class="text-center text-lg font-semibold ltr:sm:text-left rtl:sm:text-right">Calendar</div>
                    <div class="mt-2 flex flex-wrap items-center justify-center sm:justify-start">
                        <div class="flex items-center ltr:mr-4 rtl:ml-4">
                            <div class="h-2.5 w-2.5 rounded-sm bg-primary ltr:mr-2 rtl:ml-2"></div>
                            <div>Work</div>
                        </div>
                        <div class="flex items-center ltr:mr-4 rtl:ml-4">
                            <div class="h-2.5 w-2.5 rounded-sm bg-info ltr:mr-2 rtl:ml-2"></div>
                            <div>Travel</div>
                        </div>
                        <div class="flex items-center ltr:mr-4 rtl:ml-4">
                            <div class="h-2.5 w-2.5 rounded-sm bg-success ltr:mr-2 rtl:ml-2"></div>
                            <div>Personal</div>
                        </div>
                        <div class="flex items-center">
                            <div class="h-2.5 w-2.5 rounded-sm bg-danger ltr:mr-2 rtl:ml-2"></div>
                            <div>Important</div>
                        </div>
                    </div>
                </div>
                <button type="button" class="btn btn-primary" (click)="editEvent()">
                    <icon-plus class="ltr:mr-2 rtl:ml-2" />
                    Create Event
                </button>
            </div>
            <div class="calendar-wrapper">
                <full-calendar id="calendar" #calendar [options]="calendarOptions" [deepChangeDetection]="true">
                    <ng-template #eventContent let-arg>
                        <div class="fc-event-main-frame flex items-center px-1 py-0.5 text-white">
                            <div class="fc-event-time px-0.5 font-semibold">{{ arg.timeText }}</div>
                            <div class="fc-event-title-container">
                                <div class="fc-event-title fc-sticky px-0.5 !font-medium">{{ arg.event.title }}</div>
                            </div>
                        </div>
                    </ng-template>
                </full-calendar>
            </div>
        </div>
    </div>
</div>
